import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Region from 'legacy/apps/region/components/region'
import createReactClass from 'create-react-class'

import s from './selectable-gis-region.module.scss'

export default createReactClass({
  displayName: 'SelectableRegion',

  propTypes: {
    region: PropTypes.shape({
      pk: PropTypes.number,
      name: PropTypes.string,
      wkt: PropTypes.string,
    }),
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
    className: PropTypes.string,
    itemCassName: PropTypes.string,
    nameClassName: PropTypes.string,
    children: PropTypes.node,
  },

  onClick() {
    this.props.onSelect(this.props.region)
  },

  render() {
    const {
      region,
      className,
      itemCassName,
      nameClassName,
      selected,
      children,
    } = this.props

    return (
      <div className={classNames(s.region, className)} onClick={this.onClick}>
        <div
          className={classNames(s.item, itemCassName, {
            [s._selected]: selected,
          })}
        >
          <Region
            wkt={region.wkt}
            readOnly
            mapConfig={{
              scrollwheel: false,
              zoomControl: true,
            }}
          />
        </div>
        <div className={classNames(s.name, nameClassName)}>
          {region.name}
          {children}
        </div>
      </div>
    )
  },
})
